'use strict';

/* globals RELATIVE_PATH, $, utils, socket */

require([
	RELATIVE_PATH + '/plugins/nodebb-plugin-courses/static/vendor/vue.js',
	RELATIVE_PATH + '/plugins/nodebb-plugin-video/static/vendor/videojs/video.js',
	'bootbox',
], function (Vue, videojs, bootbox) {
	var internals = {};

	Vue.component('course-chapter', {
		props: ['initData', 'chapter', 'goToNextChapter', 'isLastChapter', 'isStarted', 'autoplay', 'currentChapter', 'saveAttempt'],
		data: function () {
			return {
				chapters: this.initData.chapters,
			};
		},
		watch: {
			chapter: function () {
				this.renderVideo();
			},
		},
		mounted: function () {
			this.$nextTick(function () {
				this.renderVideo();
			});
		},
		methods: {
			renderVideo: function () {
				var me = this;

				if (this.chapter.video) {
					setTimeout(function () {
						internals.addVideo(me.chapter.video, me.chapter.videoThumbnail || '', function (videoId) {
							me.initVideoPlayer(videoId);
						});
					}, 250);
				} else {
					internals.clearVideo();
				}
			},
			initVideoPlayer: function (videoId) {
				var _self = this;
				var timer = null;

				_self.player = videojs.getPlayer('video-' + videoId);

				_self.player.on('ended', function () {
					socket.emit('plugins.coursesAnalytics.finishedVideoInChapter', { courseId: _self.initData.course.courseId, uuid: _self.initData.uuid, chapter: _self.currentChapter, groupName: _self.initData.group.name });

					if (_self.isLastChapter) {
						_self.goToNextChapter();

						return;
					}

					bootbox.confirm(_self.initData.translations.goToNextChapterConfirmation, function (confirm) {
						if (!confirm) {
							return;
						}

						_self.goToNextChapter();
					});
				});

				_self.player.on('play', function () {
					_self.saveAttempt();
					
					timer = window.setInterval(function() {
						socket.emit('plugins.coursesAnalytics.chapterProgress', { courseId: _self.initData.course.courseId, uuid: _self.initData.uuid, chapter: _self.currentChapter, groupName: _self.initData.group.name });
					}, 5000);
					
					if (_self.player.currentTime()) {
						socket.emit('plugins.coursesAnalytics.startedVideoInChapter', { courseId: _self.initData.course.courseId, uuid: _self.initData.uuid, chapter: _self.currentChapter, groupName: _self.initData.group.name });
					}
				});

				_self.player.on('pause', function () {
					if (timer) clearInterval(timer);
					
					if (_self.player.currentTime()) {
						socket.emit('plugins.coursesAnalytics.startedVideoInChapter', { courseId: _self.initData.course.courseId, uuid: _self.initData.uuid, chapter: _self.currentChapter, groupName: _self.initData.group.name });
					}
				});

				if (_self.isStarted && _self.autoplay) {
					_self.player.play();
				}
			},
		},
		template:
		'<div>' +
			'<div class="row chapter-info">' +
				'<div class="col-md-12">' +
					'<p v-html="chapter.description"></p>' +
				'</div>' +
			'</div>' +
			'<div class="chapter-video"></div>' +
			'<div class="row" v-if="chapter.footerImage">' +
				'<div class="col-md-12">' +
					'<img :src="chapter.footerImage" style="width: 100%; margin: 15px 0" alt="" />' +
				'</div>' +
			'</div>' +
			'<div class="row chapter-info">' +
				'<div class="col-md-12">' +
					'<p v-html="chapter.footerText"></p>' +
				'</div>' +
			'</div>' +
		'</div>',
	});

	// workaround
	internals.addVideo = function (video, thumbnail, callback) {
		var id = utils.generateUUID();

		var videoElement = $('<div class="' + id + '" data-video-url="' + video + '" data-video-thumbnail="' + thumbnail + '"></div>');

		$('.chapter-video').html(videoElement);

		$('.' + id).customVideo(null, function (videoId) {
			callback(videoId);
		});
	};

	internals.clearVideo = function () {
		$('.chapter-video').html('');
	};
});
